import {
    styledInput,
} from 'components/Form/styles/FormView'

export const styledInputFullWidth = {
    ...styledInput,
    boxSizing: 'border-box',
    width: '100%',
}
